import { RadioButtonWithText } from 'components/ui/RadioButtonWithText/RadioButtonWithText';
import { RadioButtonWithTextGroup } from 'components/ui/RadioButtonWithText/RadioButtonWithTextGroup';
import { ServiceTypes } from 'constants/ServiceTypes';
import React, { useEffect } from 'react';
import { FeatureConfigService } from 'services/FeatureConfigService';
import { useInjection } from 'services/ioc/ioc.react';
import { LineupStore } from 'stores/LineupStore';
import { SessionStore } from 'stores/SessionStore';
import { Description, GameType, PageOne, ResumeGameTooltip, TitleWrapper } from './CreateGamePageStyles';

interface IProps {
  isPrivateGameCallback: (value: boolean) => void;
  isResumeGame: boolean;
  isPrivateGame: boolean | null;
}

const CreateGamePage: React.FC<IProps> = (props) => {
  const { isPrivateGameCallback, isResumeGame, isPrivateGame } = props;
  const lineupStore = useInjection<LineupStore>(ServiceTypes.LineupStore);
  const featureConfigService = useInjection<FeatureConfigService>(ServiceTypes.FeatureConfigService);
  const sessionStore = useInjection<SessionStore>(ServiceTypes.SessionStore);

  useEffect(() => {
    if (isResumeGame) {
      lineupStore.setIsVideoCaptureEnabled(sessionStore.currentSessionMode.isVideoCaptureEnabled);
      lineupStore.setIsPlayerTrackingEnabled(sessionStore.currentSessionMode.isPlayerTrackingEnabled);
      return;
    }

    lineupStore.setIsVideoCaptureEnabled(featureConfigService.getConfig().isUploadVideoEnabled);
    lineupStore.setIsPlayerTrackingEnabled(featureConfigService.getConfig().isPlayerTrackingEnabled);

    if (isPrivateGame || !featureConfigService.getConfig().isUploadVideoEnabled) {
      lineupStore.setIsPlayerTrackingEnabled(false);
    }
  }, [isPrivateGame]);

  return (
    <PageOne>
      <TitleWrapper>
        <Description>Before creating a game, please check that it does not already exist in the schedule.</Description>
        <GameType>Select game type</GameType>
      </TitleWrapper>
      <RadioButtonWithTextGroup>
        <RadioButtonWithText
          id='officialGame'
          checked={isPrivateGame === false}
          title='Official Game'
          text='This is an official game that isn’t currently appearing on the schedule, data from this game may be distributed by Trackman.'
          disabled={(isResumeGame && isPrivateGame) || !featureConfigService.getConfig().isNetworkedSystem}
          onClickCallback={(): void => isPrivateGameCallback(false)}
          data-test='official-game'
        />
        <RadioButtonWithText
          id='privateGame'
          title='Private game'
          text='This is an unofficial game, data from this game will not be distributed by Trackman.'
          checked={isPrivateGame === true}
          disabled={isResumeGame && !isPrivateGame}
          onClickCallback={(): void => isPrivateGameCallback(true)}
          data-test='private-game'
        />
      </RadioButtonWithTextGroup>
      {isResumeGame && (
        <ResumeGameTooltip>
          Cannot change this value if session is already active. If you want to start a{isPrivateGame ? 'n Official' : ' Private'} game, you
          need to end this one.
        </ResumeGameTooltip>
      )}
    </PageOne>
  );
};

export default CreateGamePage;
